/**
 * Contest module - aggregates contest functionality
 * @module lib/contest
 */

const { resolveContestArticleId, buildContestIframeUrl, buildContestActiveUrl } = require('./urls');
const { fetchActiveContest } = require('./query');
const { ensureContestIframeResizer, createContestIframeModule } = require('./iframe');

module.exports = {
  resolveContestArticleId,
  buildContestIframeUrl,
  buildContestActiveUrl,
  fetchActiveContest,
  ensureContestIframeResizer,
  createContestIframeModule
};
